import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AccessKeysDashboardQueryKeys } from "modules/AccessKeysDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PublicAccount } from "models";

type CreateAccountPayload = {
  contact: string;
  dealer_id: number;
  name: string;
  purpose: string;
};

export const useCreateAccountMutation = () =>
  useTypedMutation<CreateAccountPayload, PublicAccount>({
    mutationFn: async payload => (await ApiInstance.post("/publicapi/account/create", payload, ENV.dealerBaseURL)).data,
    onSuccess: (_, createdAccount) => {
      const accounts = typedQueryClient.getQueryData(AccessKeysDashboardQueryKeys.accounts);
      typedQueryClient.setQueryData(AccessKeysDashboardQueryKeys.accounts, [...(accounts || []), createdAccount]);
    }
  });
